<!-- highlight -->
<div class="flex-basis highlight-box-btn">
  <div accessibleTooltip [tooltip]="(isDisabled('HL') ? 'design.tool.highlight.disabled' : 'design.tool.highlight') | translate" triggers="manual">
    <button
      class="btn btn-clear highlight"
      [disabled]="isDisabled('HL')"
      [ngClass]="{ 'bottom-marked': isSelected('HL'), disabled: isDisabled('HL') }"
      (click)="select('HL')"
      type="button"
      data-tooltype="highlight"
      placement="bottom"
      id="add-highlight"
      [rlTabIndex]
      [attr.aria-label]="(isDisabled('HL') ? 'design.tool.highlight.disabled' : 'design.tool.highlight') | translate">
      <span class="sr-only">{{ (isDisabled('HL') ? 'design.tool.highlight.disabled' : 'design.tool.highlight') | translate }}</span>
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="highlighter" class="svg-inline--fa fa-highlighter fa-w-17" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 544 512">
        <path
          fill="currentColor"
          d="M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"></path>
      </svg>
    </button>
  </div>
</div>
<!-- comments -->
<div class="flex-basis comments-box-btn">
  <button
    class="btn btn-clear comment"
    [disabled]="isDisabled('CMT')"
    [ngClass]="{ 'bottom-marked': isSelected('CMT'), disabled: isDisabled('CMT') }"
    (click)="select('CMT')"
    type="button"
    data-tooltype="point"
    accessibleTooltip
    [tooltip]="'design.tool.comment' | translate"
    triggers="manual"
    placement="bottom"
    id="add-comment"
    [rlAria]
    [rlTabIndex]>
    <span class="sr-only">{{ 'design.tool.comment' | translate }}</span>
    <i class="fa fa-comment"></i>
  </button>
</div>
<!-- shape -->
<div class="flex-basis seperator rectangle-box-btn">
  <button
    class="btn btn-clear rectangle"
    [disabled]="isDisabled('SHAPE') && isDisabled('SHAPE_NO_CMT')"
    [ngClass]="{ 'bottom-marked': isSelected('SHAPE'), disabled: isDisabled('SHAPE') && isDisabled('SHAPE_NO_CMT') }"
    (click)="select('SHAPE')"
    type="button"
    data-tooltype="area"
    accessibleTooltip
    [tooltip]="'design.tool.shape' | translate"
    triggers="manual"
    placement="bottom"
    [rlAria]
    [rlTabIndex]
    id="add-shape">
    <span class="sr-only">{{ 'design.tool.shape' | translate }}</span>
    <i class="fa fa-square-o"></i>
  </button>
  <div *ngIf="!isDisabled('SHAPE') || !isDisabled('SHAPE_NO_CMT')" dropdown id="select-recantgle-color" class="btn-group" [(isOpen)]="displayShapeMenu">
    <button
      [ngClass]="{ disabled: isDisabled('SHAPE') && isDisabled('SHAPE_NO_CMT') }"
      dropdownToggle
      name="edit-section-menu"
      type="button"
      class="btn btn-clear no-padding caret-holder dropdown-toggle"
      id="select-shape-color"
      accessibleTooltip
      [tooltip]="'design.tool.shape.select_color' | translate"
      triggers="manual"
      placement="bottom"
      [rlAria]
      [rlTabIndex]>
      <span class="sr-only">{{ 'design.tool.shape.select_color' | translate }}</span>
      <span class="caret"></span>
    </button>
    <ul *dropdownMenu role="menu" class="dropdown-menu dropdown-menu-right auto-width">
      <li>
        <a (click)="select('SHAPE', { color: 'black' })" id="select-shape-black" [rlTabIndex] href="javascript:void(0);" [attr.aria-label]="'design.tool.shape.black' | translate">
          <i class="fa fa-square-o"></i>
          <span class="sr-only">{{ 'design.tool.shape.black' | translate }}</span>
          <span>{{ 'design.tool.shape.black' | translate }}</span>
        </a>
      </li>
      <li>
        <a (click)="select('SHAPE', { color: 'green' })" id="select-shape-green" href="" [rlTabIndex] href="javascript:void(0);" [attr.aria-label]="'design.tool.shape.green' | translate">
          <span class="ColorGreen">
            <i class="fa fa-square-o"></i>
            <span class="sr-only">{{ 'design.tool.shape.green' | translate }}</span>
            <span>{{ 'design.tool.shape.green' | translate }}</span>
          </span>
        </a>
      </li>
      <li class="ColorRed">
        <a (click)="select('SHAPE', { color: 'orange' })" id="select-shape-orange" [rlTabIndex] href="javascript:void(0);" [attr.aria-label]="'design.tool.shape.orange' | translate">
          <span class="ColorOrange">
            <i class="fa fa-square-o"></i>
            <span class="sr-only">{{ 'design.tool.shape.orange' | translate }}</span>
            <span>{{ 'design.tool.shape.orange' | translate }}</span>
          </span>
        </a>
      </li>
      <li class="ColorOrange">
        <a (click)="select('SHAPE', { color: 'red' })" id="select-shape-red" [rlTabIndex] href="javascript:void(0);" [attr.aria-label]="'design.tool.shape.red' | translate">
          <span class="ColorRed">
            <i class="fa fa-square-o"></i>
            <span class="sr-only">{{ 'design.tool.shape.red' | translate }}</span>
            <span>{{ 'design.tool.shape.red' | translate }}</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>
